import {
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';

@Directive({
  selector: '[clickOutside]',
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
  @Output() clickOutside = new EventEmitter<void>();

  clickOutsideSubscription!: Subscription;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    this.clickOutsideSubscription = fromEvent(document, 'click').subscribe(
      (event: any) => {
        const targetElement = event.target as HTMLElement;
        if (!this.elementRef.nativeElement.contains(targetElement)) {
          this.clickOutside.emit();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.clickOutsideSubscription) {
      this.clickOutsideSubscription.unsubscribe();
    }
  }
}
